// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuillButton-buttonIcon__JKx9L{display:block;min-width:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonIcon": "QuillButton-buttonIcon__JKx9L"
};
export default ___CSS_LOADER_EXPORT___;
